import styled from "styled-components";

const ListItem = styled.li`
  margin-bottom: 8px;
`;

export default ListItem;
